export const APP_VERSION = "1.2.9";
export const APP_BUILD = "2026.07.14.9";
